var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:[
    'overflow-hidden rounded-lg shadow',
    _vm.active ? 'bg-green-600' : 'bg-white',
    _vm.clickable && !_vm.active ? 'cursor-pointer hover:bg-gray-50' : '',
  ],attrs:{"id":_vm.id},on:{"click":function($event){return _vm.$emit('click')}}},[_c('div',{staticClass:"h-full relative p-4"},[_c('div',{staticClass:"h-full flex items-center"},[_c('div',{staticClass:"h-full w-0 flex-1"},[_c('div',{staticClass:"h-full flex flex-col justify-between"},[_c('div',{staticClass:"flex items-center justify-between md:block lg:flex"},[_c('div',{class:[
                'truncate text-sm font-medium',
                _vm.active ? 'text-white' : 'text-gray-900',
              ]},[_vm._v(" "+_vm._s(_vm.label)+" ")]),_vm._t("label-action")],2),_c('div',{staticClass:"mt-6"},[_c('div',{class:[
                'text-lg font-bold',
                _vm.active ? 'text-white' : 'text-gray-900',
              ],attrs:{"id":`${_vm.id}-value`}},[_vm._v(" "+_vm._s(_vm._f("toCurrency")(_vm.value))+" ")])])])]),_c('div',{class:[
          'absolute -bottom-4 -right-3 flex-shrink-0',
          _vm.active ? 'text-white' : 'text-gray-200',
        ]},[_c('svg',{staticClass:"h-16 w-16",attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 20 20","fill":"currentColor"}},[_c('path',{attrs:{"d":"M5.5 16a3.5 3.5 0 01-.369-6.98 4 4 0 117.753-1.977A4.5 4.5 0 1113.5 16h-8z"}})])])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }